import { render, staticRenderFns } from "./receitas.vue?vue&type=template&id=39f59769&"
import script from "./receitas.vue?vue&type=script&lang=js&"
export * from "./receitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports